export default __webpack_public_path__ + "static/media/logmetrics-logo.5052b9ae.svg";